import { render, staticRenderFns } from "./EditTerm.vue?vue&type=template&id=4823a75a&"
import script from "./EditTerm.vue?vue&type=script&lang=js&"
export * from "./EditTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports